import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { ThreadDetailPage } from '@/features/forum';

export const Route = createFileRoute('/forum_/$threadId')({
  component: ThreadRoute,
});

function ThreadRoute(): ReactNode {
  const { threadId } = Route.useParams();
  return <ThreadDetailPage threadId={threadId} />;
}
